export default __webpack_public_path__ + "static/media/vehicle.10a403f4.png";